// Work outside a router navigation that should show the bar, such as signing out before the
// redirect. Navigations themselves are tracked from the router's own state.
let manualCount = 0;
const listeners = new Set<() => void>();
const notify = () => {
  for (const listener of listeners) listener();
};

export const startRouteProgress = () => {
  manualCount += 1;
  notify();
};

export const stopRouteProgress = () => {
  manualCount = Math.max(0, manualCount - 1);
  notify();
};

export const subscribeToRouteProgress = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/** Whether work outside a navigation (`startRouteProgress`) is running. */
export const isManualRouteProgressRunning = () => manualCount > 0;
